module.exports = __webpack_public_path__ + "img/kurand_ec_ksm_bnr_s_02.c3bf9149.png";